import { motion } from "framer-motion";

const BADGE_EMOJI = (pct) => {
  if (pct >= 75) return "✅";
  if (pct >= 50) return "🌟";
  if (pct >= 25) return "📖";
  return "🌱";
};

const BAR_COLOR = (pct) => {
  if (pct >= 75) return "bg-green-500";
  if (pct >= 50) return "bg-[#448AFF]";
  if (pct >= 25) return "bg-[#FFD740]";
  return "bg-muted-foreground/40";
};

export const InlineMasteryPanel = ({ masteryData = [], loading = false, isAnonymous = false }) => {
  if (!masteryData.length) {
    return (
      <div className="rounded-2xl border border-border bg-card p-5 text-center">
        {isAnonymous ? (
          <p className="text-sm text-muted-foreground">
            Sign in to track your learning progress! 🔐
          </p>
        ) : loading ? (
          <div className="flex items-center justify-center gap-2 py-1">
            <div className="w-4 h-4 rounded-full border-2 border-[#448AFF] border-t-transparent animate-spin" />
            <p className="text-sm text-muted-foreground">Loading your achievements...</p>
          </div>
        ) : (
          <p className="text-sm text-muted-foreground">
            Generate more stories to build your achievements! 🚀
          </p>
        )}
      </div>
    );
  }

  return (
    <div className="rounded-2xl border border-border bg-card p-5 space-y-4" data-testid="inline-mastery-panel">
      <h3 className="font-heading font-bold text-base">Your Learning Achievements 🏆</h3>
      <div className="space-y-3">
        {masteryData.map((topic, i) => (
          <div key={i} className="space-y-1.5">
            <div className="flex justify-between items-center gap-2">
              <span className="text-xs truncate max-w-[220px] text-foreground">
                {BADGE_EMOJI(topic.mastery_pct)}{" "}
                {topic.content_preview?.slice(0, 35) || "Topic"}
                {(topic.content_preview?.length || 0) > 35 ? "…" : ""}
              </span>
              <span className="text-xs text-muted-foreground shrink-0 font-mono">
                {topic.mastery_pct}%
              </span>
            </div>
            <div className="h-1.5 rounded-full bg-muted overflow-hidden">
              <motion.div
                initial={{ width: 0 }}
                animate={{ width: `${topic.mastery_pct}%` }}
                transition={{ duration: 0.7, delay: i * 0.06, ease: "easeOut" }}
                className={`h-full rounded-full ${BAR_COLOR(topic.mastery_pct)}`}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
